import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dismiss: {
		id: 'platform-ui-banners-announcement.banner-v2.announcement.dismiss',
		defaultMessage: 'Dismiss',
		description: 'The label for the button that dismisses the banner',
	},
});
